export default "__VITE_ASSET__Cn23oZEJ__"